import "react/jsx-runtime";
import React from "react";
const InitialBlockEnvironment = {
  environment: "prod"
};
const BlockEnvironmentContext = React.createContext(InitialBlockEnvironment);
const useBlockEnvironment = () => {
  return React.useContext(BlockEnvironmentContext);
};
export {
  useBlockEnvironment
};
